export default __webpack_public_path__ + "static/media/graph.8cf6c3b3.jpg";